<template>
	<div>
		<Header />
		<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; height: 80vh">
			<img src="@/assets/img/404.png" style="height: 70%; max-height: 380px">
		<p style="font-weight: bold; text-align: center;margin: 0 0 40px 0" class="text-primary">{{translate(locale.notFound)}}</p>
		<router-link to="/"><md-button class="md-raised md-primary" style="padding: 0"><i class="material-icons button-icon">home</i> {{translate(locale.home)}}</md-button></router-link>
		</div>
	</div>
</template>

<script>
	import Header from '../components/Header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
			}
		},
		created() {

			// setTimeout(() => {
				// this.$router.push("/dashboard");
			// }, 2000)

			
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue